module.exports = __webpack_public_path__ + "img/people4.943d4591.png";